// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24HY8","colMin":"styles_colMin__lhlex"};